import React, { Component } from 'react';
import voucher from '../../../../images/VOUCHER_WINNER.png';
import '../../../../styles/App.css';
import Config from "../../../../config/config";

import WakeLockService from "../../../../services/WakeLockService";

export default class VoucherWinner extends Component {

	constructor(props) {
		super(props);
		
		console.log("VoucherWinner::", props);
		if (this.props.result.isFinal) {
			WakeLockService.disable();	
		}
		localStorage.setItem("game_end_loaded", 1);
	}

	componentDidMount() {
		window.gtag('config', Config.googleAnalyticsCode, {
			'page_title' : 'Winner',
			'page_path': '/winner'
		});
	}
	
	render() {
		const score = this.props.result.isFinal ? this.props.result.totalScore : this.props.result.score;		

		return(
			<div className="voucher voucherWinner">								
				<img className="voucherImage" src={voucher} style={{width:"100%"}} alt="winner" />
				<div className="voucherTexts">
					<div className="winnerDiv">
						<h2>WINNER!</h2>
						<h3>{score} POINTS</h3>
					</div>

					<div className="winnerInfo">
						{this.props.userName}<br/>
						JIJ HEBT GEWONNEN!!!
					</div>
					
					<div className="contactDiv">
						Je hebt de VUE Filmvoucher  te pakken!<br/> 
						<a target="_blank" href="https://www.linkedin.com/in/boris-boonzajer-flaes-77372228/" rel="noopener noreferrer" className="shareText">Kom in contact met ons</a> 
					</div>
				</div>
			</div>
		)
	}
}
		



// WEBPACK FOOTER //
// ./src/components/pages/Quiz/VoucherWinner/VoucherWinner.js